import React from "react";
import "./Loader.css";
import logo from "../assets/logo.png";

export default function Loader() {
  return (
    <div className="loader-container">
      <img src={logo} alt="Glamur Paints Logo" className="loader-logo-img" />
      <div className="spinner"></div>
    </div>
  );
}
